import {http} from '@/services/http'
import type {
	MarketingBrandResponse,
	MarketingBrand,
} from '@/models/consumer-engagement-models'
import type {Result} from '@/utilities/types'

export const fetchMarketingBrands = async (
	locale: string
): Promise<MarketingBrand[]> => {
	const endpoint = `/api/species/all/marketingbrands?locale=${locale}`
	const {data: response} =
		await http<Result<MarketingBrandResponse>>(endpoint)

	if (!response.success) {
		throw new Error('Failed to create pet profile')
	}

	return response.data.data
}
